// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#recreation .post-type {\n  display: flex;\n  align-items: center;\n  height: 32px;\n}", ""]);
// Exports
module.exports = exports;
